module.exports = __webpack_public_path__ + "static/scholle-1d4a1cc1021e44a2bbf0768c22b3904c.png";